import React from 'react'
import {BioWrapper, Person, ImageHolder, 
    Image, Name, Surname, Firstname, Career, Work} from './BioStyle';
// import bioImage from "../../images/bio-pics.jpg"
import bioImage from "../../images/chams-photshoot-4.jpg"

function Bio() {
    return (
        <BioWrapper>
            <Person>
                <ImageHolder>
                    <Image src={bioImage} alt="sample" />
                </ImageHolder>
                <Name>
                    <Surname>ubani</Surname>
                    <Firstname>friday</Firstname>
                </Name>
                <Career>Software Developer</Career>
                <Work>ChamsAccess Ltd.</Work>
            </Person>
            {/* <Wish>
                <WishHeader>Self Wish</WishHeader>
                <WishDesc>Birthdays are generally celebrated once a year on the exact day of birth and that is the sole reason i decided to celebrate mine in this fascinating way which is so special to me as a software developer. I wish myself an unforgettable, prosperous birthday with long life, more accomplishment, good health, favour, unlimited grace and funds to manage all my wishes.</WishDesc>
                <WishFooter>Hip! Hip!! Hip!!! Hurray ......</WishFooter>
            </Wish> */}
        </BioWrapper>
    )
}

export default Bio
